/*
 * WLD cart drawer (sections/wld-cart-drawer.liquid).
 * Flyttad från inline <script> så att den cachas och inte skickas med i varje
 * section-rendering av drawern. Liquid-värden läses från data-attribut på
 * [data-wld-cart-root].
 */
(function () {
  function wldCartDrawerInstance(sectionId, T_deliveryPendingStatus, T_deliveryPendingCta) {

    function qs(sel, ctx) {
      return (ctx || document).querySelector(sel);
    }

    function getRoot() {
      return document.querySelector('[data-wld-cart-root="' + sectionId + '"]');
    }

    function sectionIdFromRoot(root) {
      return (root && root.getAttribute('data-wld-cart-root')) || sectionId;
    }

    /* The delivery app's own auto-open setting opens its postcode drawer after
       every first cart addition. The cart must remain reviewable before the
       customer actively chooses delivery, so disable only that automatic path.
       The app reads this dataset value for every cart event; its normal
       "Välj leverans" button still opens the drawer through the app's click
       handler and remains fully authoritative for the delivery flow. */
    function disableDeliveryAutoOpen() {
      document.querySelectorAll('[data-grona-delivery]').forEach(function (deliveryRoot) {
        deliveryRoot.dataset.autoOpen = 'false';
      });
    }

    function syncCartEmptyState(root, itemCount) {
      if (!root) return;
      let refresh = root.querySelector('[data-wld-cart-refresh]');
      let empty = typeof itemCount === 'number'
        ? itemCount === 0
        : Boolean(refresh && refresh.dataset.wldCartEmpty === 'true');

      root.classList.toggle('is-cart-empty', empty);

      /* En tom varukorg har inget att välja leverans för — dölj "Välj
         leveranssätt". Leveransvalet ligger däremot kvar: tidigare anropades
         appens ggResetDelivery() här, vilket raderade valet (även postnumret)
         varje gång kunden tömde korgen och tvingade fram ett nytt val vid nästa
         vara. Ett val vars beställningsstopp passerat rensar appen själv. */
      if (empty) root.classList.remove('is-delivery-pending');
    }

    function setOpen(root, open) {
      if (!root) return;
      let sid = sectionIdFromRoot(root);
      let bd = root.querySelector('[data-wld-cart-bd="' + sid + '"]');
      let panel = root.querySelector('[data-wld-cart-panel="' + sid + '"]');
      let trigger = document.getElementById('wld-nav-cart-btn');
      if (!bd || !panel) return;
      if (open) {
        bd.classList.add('open');
        panel.classList.add('open');
        bd.setAttribute('aria-hidden', 'false');
        panel.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('wld-cart-open');
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
        /* Cart changed while closed (e.g. from a product card stepper) — bring the
           lines up to date now, on open, instead of doing a heavy refresh per click. */
        if (root.dataset.wldCartDirty === '1') {
          root.dataset.wldCartDirty = '0';
          refreshInner(root);
        }
      } else {
        bd.classList.remove('open');
        panel.classList.remove('open');
        bd.setAttribute('aria-hidden', 'true');
        panel.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('wld-cart-open');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      }
    }

    function isOpen(root) {
      if (!root) return false;
      let sid = sectionIdFromRoot(root);
      let panel = root.querySelector('[data-wld-cart-panel="' + sid + '"]');
      return !!(panel && panel.classList.contains('open'));
    }

    function updateHeaderCount(count) {
      document.querySelectorAll('.nav-cart-btn__count').forEach(function (el) {
        el.textContent = String(count);
        el.dataset.count = String(count);
      });
    }

    function syncHeaderFreeShippingTag(root, subtotalCents) {
      var trigger = document.getElementById('wld-nav-cart-btn');
      if (!trigger || !root) return;

      var threshold = Number(root.dataset.wldFreeShippingThreshold || 0);
      var isQualified = typeof subtotalCents === 'number' && threshold > 0
        ? subtotalCents >= threshold
        : Boolean(root.querySelector('.cart-shipping-bar.is-qualified'));
      var tag = trigger.querySelector('.nav-cart-btn__free-shipping-tag');

      if (isQualified && !tag) {
        tag = document.createElement('span');
        tag.className = 'nav-cart-btn__free-shipping-tag';
        tag.setAttribute('aria-hidden', 'true');
        tag.textContent = 'FRI FRAKT';
        trigger.appendChild(tag);
      } else if (!isQualified && tag) {
        tag.remove();
      }
    }

    let toastTimer = null;

    function findAddedItem(detail) {
      if (!detail || !detail.resource || !Array.isArray(detail.resource.items)) return null;
      let variantId = detail.sourceId || (detail.data && detail.data.variantId);
      if (!variantId) return detail.resource.items[0] || null;
      return detail.resource.items.find(function (item) {
        return String(item.variant_id) === String(variantId) || String(item.id) === String(variantId);
      }) || detail.resource.items[0] || null;
    }

    function showToast(root, detail) {
      if (!root || !detail || !detail.data || detail.data.didError) return;
      if (detail.data.source !== 'product-form-component' && detail.data.source !== 'quick-order-list') return;

      let sid = sectionIdFromRoot(root);
      let toast = root.querySelector('[data-wld-cart-toast="' + sid + '"]');
      if (!toast) return;

      let item = findAddedItem(detail);
      let titleEl = toast.querySelector('[data-wld-cart-toast-title]');
      if (titleEl) {
        let productTitle = item && (item.product_title || item.title);
        titleEl.textContent = (productTitle || 'Varan') + ' är tillagd';
      }

      toast.classList.add('is-visible');
      if (toastTimer) window.clearTimeout(toastTimer);
      toastTimer = window.setTimeout(function () {
        toast.classList.remove('is-visible');
      }, 4200);
    }

    function hideToast(root) {
      if (!root) return;
      let sid = sectionIdFromRoot(root);
      let toast = root.querySelector('[data-wld-cart-toast="' + sid + '"]');
      if (toast) toast.classList.remove('is-visible');
      if (toastTimer) window.clearTimeout(toastTimer);
      toastTimer = null;
    }

    /* Error toast — triggered by the global `cart:stock-error` event from ANY
       surface (card / search / drawer / page). Independent timer so it doesn't
       fight the add-toast. */
    let errorToastTimer = null;
    function showErrorToast(root, message) {
      if (!root) return;
      let sid = sectionIdFromRoot(root);
      let toast = root.querySelector('[data-wld-cart-error-toast="' + sid + '"]');
      if (!toast) return;
      if (message) {
        let titleEl = toast.querySelector('[data-wld-cart-error-toast-title]');
        if (titleEl) titleEl.textContent = message;
      }
      toast.classList.add('is-visible');
      if (errorToastTimer) window.clearTimeout(errorToastTimer);
      errorToastTimer = window.setTimeout(function () {
        toast.classList.remove('is-visible');
      }, 4200);
    }

    function refreshInner(root, done) {
      let sid = sectionIdFromRoot(root);
      let wasOpen = isOpen(root);
      let url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + '?sections=' + encodeURIComponent(sid);
      fetch(url)
        .then(function (r) {
          return r.json();
        })
        .then(function (data) {
          let html = data[sid];
          if (!html && data && typeof data === 'object') {
            let keys = Object.keys(data);
            if (keys.length === 1) html = data[keys[0]];
          }
          if (!html || !root) {
            if (done) done();
            return;
          }
          let doc = new DOMParser().parseFromString(html, 'text/html');
          let sec = doc.querySelector('[id^="shopify-section-"]');
          let nextInner = sec && sec.querySelector('[data-wld-cart-refresh]');
          let target = root.querySelector('[data-wld-cart-refresh]');
          if (nextInner && target) {
            /* The delivery app injects its summary ("Din leverans") at the top of
               .cart-panel. Replacing the panel drops it until the app re-renders,
               which flickers. Carry the live node over to the new panel; the app
               still replaces it in one step when it re-renders. */
            let deliverySummary = target.querySelector('.cart-panel [data-gg-cart-summary]');
            target.innerHTML = nextInner.innerHTML;
            target.dataset.wldCartEmpty = nextInner.dataset.wldCartEmpty || 'false';
            let nextPanel = target.querySelector('.cart-panel');
            if (deliverySummary && nextPanel && target.dataset.wldCartEmpty !== 'true' && !nextPanel.querySelector('[data-gg-cart-summary]')) {
              nextPanel.insertAdjacentElement('afterbegin', deliverySummary);
            }
            syncCartEmptyState(root);
            syncHeaderFreeShippingTag(root);
            if (wasOpen) setOpen(root, true);
          }
          if (done) done();
        })
        .catch(function () {
          if (done) done();
        });
    }

    /* Cart changed while the drawer is closed: re-render it in the background,
       debounced so a burst of +/- or adds collapses into one request. Doing it
       on open instead swaps the content (incl. the delivery header) in front of
       the user, which reads as a flicker. The dirty flag stays as a fallback if
       the drawer is opened before the debounce fires. */
    function scheduleBackgroundRefresh(root) {
      root.dataset.wldCartDirty = '1';
      if (root.__wldBgRefresh) clearTimeout(root.__wldBgRefresh);
      root.__wldBgRefresh = setTimeout(function () {
        root.__wldBgRefresh = null;
        if (root.dataset.wldCartDirty !== '1' || isOpen(root)) return;
        root.dataset.wldCartDirty = '0';
        refreshInner(root);
      }, 400);
    }

    /* Update ONLY the values that change on a +/- (line prices, subtotal, footer
       note, shipping bar, header count) by swapping those small nodes in place —
       WITHOUT replacing the panel/items structure. That structural replacement is
       what makes the whole drawer "jump". Falls back to the full refreshInner if
       the row set changed (add/remove) or the new markup can't be matched, so the
       safe/rare cases keep today's proven behaviour. */
    function patchInner(root, done) {
      let sid = sectionIdFromRoot(root);
      let url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + '?sections=' + encodeURIComponent(sid);
      fetch(url)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          let html = data[sid];
          if (!html && data && typeof data === 'object') {
            let keys = Object.keys(data);
            if (keys.length === 1) html = data[keys[0]];
          }
          if (!html || !root) { return refreshInner(root, done); }

          let doc = new DOMParser().parseFromString(html, 'text/html');
          let nextRoot = doc.querySelector('[data-wld-cart-refresh]');
          let curRoot = root.querySelector('[data-wld-cart-refresh]');
          if (!nextRoot || !curRoot) { return refreshInner(root, done); }

          let nextRows = nextRoot.querySelectorAll('.cart-item[data-cart-line]');
          let curRows = curRoot.querySelectorAll('.cart-item[data-cart-line]');
          /* Row set changed (item removed / added) → structure differs → full
             refresh (rare, and today's behaviour is correct there). */
          if (nextRows.length !== curRows.length || nextRows.length === 0) {
            return refreshInner(root, done);
          }

          /* Per-row: update price + the qty display (server truth), keyed by line. */
          let ok = true;
          nextRows.forEach(function (nextRow) {
            let line = nextRow.getAttribute('data-cart-line');
            let curRow = curRoot.querySelector('.cart-item[data-cart-line="' + line + '"]');
            if (!curRow) { ok = false; return; }
            let np = nextRow.querySelector('.cart-item-price');
            let cp = curRow.querySelector('.cart-item-price');
            /* Preserve the sale-price markup and its CSS classes when quantity changes. */
            if (np && cp) cp.innerHTML = np.innerHTML;
            let nq = nextRow.getAttribute('data-cart-qty');
            if (nq != null) curRow.setAttribute('data-cart-qty', nq);
            let nd = nextRow.querySelector('[data-cart-qty-display]');
            let cd = curRow.querySelector('[data-cart-qty-display]');
            if (nd && cd) cd.innerHTML = nd.innerHTML;
          });
          if (!ok) { return refreshInner(root, done); }

          /* If a conditionally-rendered block APPEARS or DISAPPEARS (e.g. crossing
             the free-shipping threshold shows/hides the bar), that's a structural
             change → full refresh so we don't leave a stale/missing node. Only
             patch in place when presence matches on both sides. */
          let conditionalSel = ['.cart-shipping-bar', '.cart-exact-weight-reservation'];
          let presenceChanged = conditionalSel.some(function (sel) {
            return !!nextRoot.querySelector(sel) !== !!curRoot.querySelector(sel);
          });
          if (presenceChanged) { return refreshInner(root, done); }

          /* Plain text/total nodes: inner content only, never the panel. The
             shipping value + payable total are computed from the same subtotal
             on the server, so patching them here keeps the full cost picture in
             sync on every +/- without rebuilding the footer. */
          ['.cart-subtotal-price', '[data-exact-weight-reservation-value]', '.cart-shipping-value', '.cart-payable-price', '.cart-header-count'].forEach(function (sel) {
            let next = nextRoot.querySelector(sel);
            let cur = curRoot.querySelector(sel);
            if (next && cur) cur.innerHTML = next.innerHTML;
          });

          /* The shipping value flips to "free" (is-free class) when the cart
             crosses the free-shipping threshold — mirror that class from the
             server markup so the styling follows the number. */
          let nextShip = nextRoot.querySelector('.cart-shipping-value');
          let curShip = curRoot.querySelector('.cart-shipping-value');
          if (nextShip && curShip) {
            curShip.classList.toggle('is-free', nextShip.classList.contains('is-free'));
          }

          [
            '[data-shipping-home-template]',
            '[data-shipping-pickup-template]'
          ].forEach(function (sel) {
            let nextTemplate = nextRoot.querySelector(sel);
            let curTemplate = curRoot.querySelector(sel);
            if (nextTemplate && curTemplate) curTemplate.innerHTML = nextTemplate.innerHTML;
          });
          let nextText = nextRoot.querySelector('.cart-shipping-text');
          let curText = curRoot.querySelector('.cart-shipping-text');
          if (nextText && curText) curText.innerHTML = nextText.innerHTML;
          let nextBar = nextRoot.querySelector('.cart-shipping-bar');
          let curBar = curRoot.querySelector('.cart-shipping-bar');
          if (nextBar && curBar) {
            curBar.classList.toggle('is-qualified', nextBar.classList.contains('is-qualified'));
          }
          let nextTiers = nextRoot.querySelector('.cart-shipping-tiers');
          let curTiers = curRoot.querySelector('.cart-shipping-tiers');
          if (nextTiers && curTiers) {
            curTiers.setAttribute('aria-valuenow', nextTiers.getAttribute('aria-valuenow') || '0');
            let nextTierItems = nextTiers.querySelectorAll('[data-shipping-tier]');
            let curTierItems = curTiers.querySelectorAll('[data-shipping-tier]');
            curTierItems.forEach(function (tier, index) {
              var nextTier = nextTierItems[index];
              if (!nextTier) return;
              tier.classList.toggle('is-achieved', nextTier.classList.contains('is-achieved'));
              var nextTierFill = nextTier.querySelector('.cart-shipping-tier__fill');
              var curTierFill = tier.querySelector('.cart-shipping-tier__fill');
              if (nextTierFill && curTierFill) curTierFill.style.width = nextTierFill.style.width;
            });
          }

          /* Re-apply the currently selected delivery method only after the new
             qualified/unqualified templates are in place. */
          syncHeaderFreeShippingTag(root);
          syncShippingDeliveryWording(root);
          syncCartDeliveryState(root);
          if (done) done();
        })
        .catch(function () { return refreshInner(root, done); });
    }

    var STOCK_ERROR_TEXT = 'Tyvärr, det finns inte fler i lager just nu.';

    function changeLine(line, quantity, root) {
      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity }),
      })
        .then(function (r) {
          return r.json().then(function (body) {
            return { ok: r.ok, status: r.status, body: body };
          });
        })
        .then(function (res) {
          var cart = res.body;
          /* Inventory limit hit (422) or any error: the server did NOT apply our
             change (or only partly), but setRowQtyOptimistic already bumped the
             visible number to the rejected value. Re-sync from server truth via
             patchInner — it updates the qty, the LINE PRICE, the subtotal and the
             shipping bar in place (one source, no jump), so the price can't lag
             behind the number. patchInner falls back to a full refresh if the row
             count changed; on a stock cap the row still exists, so it patches. */
          if (!res.ok || (cart && cart.status === 422)) {
            document.dispatchEvent(new CustomEvent('cart:stock-error', {
              bubbles: true,
              detail: { message: STOCK_ERROR_TEXT },
            }));
            var anyPendingErr = Object.keys(qtyCommitTimers).length > 0;
            if (!anyPendingErr) patchInner(root);
            return;
          }
          if (cart && typeof cart.item_count === 'number') {
            updateHeaderCount(cart.item_count);
            syncCartEmptyState(root, cart.item_count);
          }
          /* Only re-render once no other line still has a pending optimistic edit,
             so a re-render triggered by line A can't flicker line B back to its
             old number before B's own commit lands. patchInner updates prices /
             totals / shipping bar in place (no panel rebuild → no "jump"), and
             falls back to the full refreshInner when a row was added/removed. */
          var anyPending = Object.keys(qtyCommitTimers).length > 0;
          if (!anyPending) patchInner(root);
          /* Tell product-card steppers to re-sync their numbers. Tagged source so
             the drawer's own cart:update listener doesn't refresh itself in a loop. */
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: cart, source: 'wld-cart-drawer' },
          }));
        })
        .catch(function () {});
    }

    /* Optimistic +/- for the drawer. Clicking updates the visible number AND the
       row's data-cart-qty INSTANTLY, then a single debounced change.js is sent
       once the burst settles. Reading the next quantity from data-cart-qty (which
       we now keep current on every click) — instead of waiting for the server —
       is what removes both the ~200ms lag and the "jumps back one" bounce (two
       fast clicks used to both read the same stale server value). refreshInner
       runs ONCE after the commit, not per click, so the cart no longer re-renders
       (jumps) on every press. Endpoints and add-to-cart flow are unchanged. */
    var qtyCommitTimers = {};
    function setRowQtyOptimistic(root, line, nextQty) {
      var row = root.querySelector('.cart-item[data-cart-line="' + line + '"]');
      if (!row) return;
      row.setAttribute('data-cart-qty', String(nextQty));
      var display = row.querySelector('[data-cart-qty-display]');
      if (display && !display.hasAttribute('data-exact-weight-display')) {
        /* Preserve the trailing unit span (" st"); only replace the leading number. */
        var unit = display.querySelector('.cart-qty-unit');
        display.textContent = String(nextQty);
        if (unit) display.appendChild(unit);
      }
    }
    function commitLineSoon(root, line, nextQty) {
      if (qtyCommitTimers[line]) window.clearTimeout(qtyCommitTimers[line]);
      qtyCommitTimers[line] = window.setTimeout(function () {
        delete qtyCommitTimers[line];
        changeLine(line, nextQty, root);
      }, 260);
    }

    /* The delivery widget writes the selected method into
       .gg-cart-delivery__title (for example "Hemleverans" or
       "Utlämningsställe"). Keep the free-delivery message aligned with that
       choice, including after Gordon replaces its markup or the cart refreshes. */
    function deliveryUsesPickupWording(root) {
      var deliveryTitle = root.querySelector('.gg-cart-delivery__title');
      if (!deliveryTitle) return false;

      var label = deliveryTitle.textContent.trim();
      if (/\bhemleverans\b/i.test(label)) return false;
      if (/välj leverans/i.test(label)) return false;

      /* Gordon shows the pickup-point name (for example "ICA Kvantum
         Strömstad") rather than the word "Utlämningsställe". A selected
         postcode plus anything other than the explicit Hemleverans label is
         therefore the reliable pickup signal. */
      return /(utlämningsställe|utlamningsstalle|ombud|pickup|service point)/i.test(label)
        || /\b\d{3}\s?\d{2}\b/.test(label);
    }

    function syncShippingDeliveryWording(root) {
      var shippingText = root.querySelector('.cart-shipping-text');
      var homeTemplate = root.querySelector('[data-shipping-home-template]');
      var pickupTemplate = root.querySelector('[data-shipping-pickup-template]');
      if (!shippingText || !homeTemplate || !pickupTemplate) return;

      var desiredHtml = deliveryUsesPickupWording(root)
        ? pickupTemplate.innerHTML
        : homeTemplate.innerHTML;

      if (shippingText.innerHTML !== desiredHtml) {
        shippingText.innerHTML = desiredHtml;
      }

    }

    function formatCartDeliverySummary(root) {
      var deliveryTitle = root.querySelector('.gg-cart-delivery__title');
      if (deliveryTitle) {
        var formattedTitle = deliveryTitle.innerHTML.replace(/\b(\d{3})\s?(\d{2})\b/g, '$1 $2');
        if (deliveryTitle.innerHTML !== formattedTitle) {
          deliveryTitle.innerHTML = formattedTitle;
        }
      }

      var monthNames = [
        'januari', 'februari', 'mars', 'april', 'maj', 'juni',
        'juli', 'augusti', 'september', 'oktober', 'november', 'december'
      ];
      var deliveryLines = root.querySelectorAll('.gg-cart-delivery__text p');
      deliveryLines.forEach(function (line) {
        var rawLine = line.textContent.trim().replace(/,\s*\d{2}:\d{2}[–-]\d{2}:\d{2}$/, '');
        var match = rawLine.match(/^(.+?)\s+(\d{1,2})\/(\d{1,2})$/);
        if (!match) return;

        var monthIndex = parseInt(match[3], 10) - 1;
        if (monthIndex < 0 || monthIndex >= monthNames.length) return;

        var formattedDate = match[1] + ' ' + parseInt(match[2], 10) + ' ' + monthNames[monthIndex];
        if (deliveryTitle && /\bhemleverans\b/i.test(deliveryTitle.textContent)) {
          try {
            var deliveryWindow = window.localStorage.getItem('wldDeliveryWindow') || '';
            if (/^\d{2}:\d{2}–\d{2}:\d{2}$/.test(deliveryWindow)) {
              formattedDate += ', ' + deliveryWindow;
            }
          } catch (error) {}
        }
        if (line.textContent.trim() !== formattedDate) {
          line.textContent = formattedDate;
        }
      });
    }

    /* Mylla-inspired sequencing without replacing the existing Gordon/WLD
       integration: the cart remains fully reviewable before a postcode or
       delivery day is chosen. The delivery widget stays authoritative; this
       function only mirrors its prompt/selected state into the drawer UI. */
    function deliveryIsPending(root) {
      var delivery = root.querySelector('.gg-cart-delivery');
      if (!delivery) return false;
      /* Klassen är den auktoritativa signalen från leverans-appen. Textmatchningen
         nedan är bara en fallback: rubriken är redigerbar via
         delivery_pending_status_text, så den får aldrig ensam styra tillståndet. */
      if (delivery.classList.contains('gg-cart-delivery--prompt')) return true;
      var deliveryTitle = delivery.querySelector('.gg-cart-delivery__title');
      if (!deliveryTitle) return false;
      var titleText = deliveryTitle.textContent || '';
      return /välj leverans/i.test(titleText)
        || (!!T_deliveryPendingStatus && titleText.trim() === T_deliveryPendingStatus.trim());
    }

    /* Speglar leveransappens öppet-läge till varukorgsroten, så CSS kan låta
       leveransvyn ersätta varukorgen i stället för att ligga bredvid den.
       Leveransappen äger .is-open; vi läser den bara. */
    /* Leveransappen stänger varukorgen (closeThemeCart) när väljaren öppnas
       från den. Då ska kunden hamna i varukorgen igen när väljaren stängs,
       oavsett om det sker med krysset, Esc eller "Gå till varukorgen". */
    var lastCartCloseAt = 0;
    var deliveryWasOpen = false;
    var reopenCartAfterDelivery = false;

    function syncDeliveryOverlayState(root) {
      var deliveryDrawer = document.querySelector('.gg-delivery__drawer.is-open');
      var deliveryOpen = !!deliveryDrawer;
      root.classList.toggle('is-delivery-open', deliveryOpen);

      if (deliveryOpen && !deliveryWasOpen) {
        reopenCartAfterDelivery = Date.now() - lastCartCloseAt < 800;
      } else if (!deliveryOpen && deliveryWasOpen && reopenCartAfterDelivery) {
        reopenCartAfterDelivery = false;
        window.setTimeout(function () {
          if (!isOpen(root)) setOpen(root, true);
        }, 260);
      }
      deliveryWasOpen = deliveryOpen;
    }

    function syncCartDeliveryState(root) {
      var delivery = root.querySelector('.gg-cart-delivery');
      if (!delivery) return;

      var pending = deliveryIsPending(root);
      root.classList.toggle('is-delivery-pending', pending);

      var deliveryCta = root.querySelector('[data-wld-delivery-cta]');
      if (deliveryCta) {
        deliveryCta.hidden = !pending;
        if (pending) {
          if (deliveryCta.textContent.trim() !== T_deliveryPendingCta) {
            deliveryCta.textContent = T_deliveryPendingCta;
          }
          /* Gordon/WLD binds its delivery-picker listener to checkout controls
             first. Activate this explicit delivery CTA just after that bind,
             then remove the checkout selector so later cart refreshes do not
             restyle it as a disabled checkout button. */
          if (deliveryCta.dataset.wldDeliveryActivationScheduled !== 'true') {
            deliveryCta.dataset.wldDeliveryActivationScheduled = 'true';
            window.setTimeout(function () {
              deliveryCta.removeAttribute('name');
              deliveryCta.classList.remove('gg-checkout-blocked');
              deliveryCta.setAttribute('aria-disabled', 'false');
              delete deliveryCta.dataset.wldDeliveryActivationScheduled;
            }, 0);
          }
        }
      }

      if (pending) {
        var deliveryTitle = delivery.querySelector('.gg-cart-delivery__title');
        if (deliveryTitle && deliveryTitle.textContent.trim() !== T_deliveryPendingStatus) {
          deliveryTitle.textContent = T_deliveryPendingStatus;
        }
        var deliveryChange = delivery.querySelector('.gg-cart-delivery__change');
        if (deliveryChange && deliveryChange.textContent.trim() !== T_deliveryPendingCta) {
          deliveryChange.textContent = T_deliveryPendingCta;
        }
      } else {
        var selectedDeliveryChange = delivery.querySelector('.gg-cart-delivery__change');
        if (selectedDeliveryChange && selectedDeliveryChange.textContent.trim() !== 'Ändra') {
          selectedDeliveryChange.textContent = 'Ändra';
        }
      }
    }

    function observeShippingDeliveryWording(root) {
      formatCartDeliverySummary(root);
      syncShippingDeliveryWording(root);
      syncCartDeliveryState(root);
      syncDeliveryOverlayState(root);
      if (root._shippingDeliveryWordingObserver) return;

      var observer = new MutationObserver(function () {
        formatCartDeliverySummary(root);
        syncShippingDeliveryWording(root);
        syncCartDeliveryState(root);
        syncDeliveryOverlayState(root);
      });
      observer.observe(root, {
        childList: true,
        subtree: true,
        characterData: true
      });
      root._shippingDeliveryWordingObserver = observer;

      /* Leveransappens panel ligger utanför varukorgsroten, så observern ovan
         ser inte när den öppnas. Bevaka dess klassattribut separat. */
      var deliveryHost = document.querySelector('.gg-delivery');
      if (deliveryHost && !root._wldDeliveryOverlayObserver) {
        var overlayObserver = new MutationObserver(function () {
          syncDeliveryOverlayState(root);
        });
        overlayObserver.observe(deliveryHost, {
          attributes: true,
          attributeFilter: ['class'],
          subtree: true
        });
        root._wldDeliveryOverlayObserver = overlayObserver;
      }
    }

    function bind(root) {
      let trigger = document.getElementById('wld-nav-cart-btn');
      let sid = sectionIdFromRoot(root);

      root.addEventListener('click', function (e) {
        let t = e.target;
        if (t.closest('[data-wld-cart-close="' + sid + '"]')) {
          lastCartCloseAt = Date.now();
          setOpen(root, false);
          if (trigger && trigger.focus) trigger.focus();
          return;
        }
        if (t.closest('[data-wld-cart-continue="' + sid + '"]')) {
          e.preventDefault();
          setOpen(root, false);
          if (trigger && trigger.focus) trigger.focus();
          return;
        }
        let dec = t.closest('[data-cart-dec]');
        if (dec) {
          e.preventDefault();
          let line = parseInt(dec.getAttribute('data-cart-dec'), 10);
          let row = root.querySelector('.cart-item[data-cart-line="' + line + '"]');
          let q = row ? parseInt(row.getAttribute('data-cart-qty'), 10) || 1 : 1;
          let next = Math.max(0, q - 1);
          setRowQtyOptimistic(root, line, next);
          commitLineSoon(root, line, next);
          return;
        }
        let inc = t.closest('[data-cart-inc]');
        if (inc) {
          e.preventDefault();
          let line2 = parseInt(inc.getAttribute('data-cart-inc'), 10);
          let row2 = root.querySelector('.cart-item[data-cart-line="' + line2 + '"]');
          let q2 = row2 ? parseInt(row2.getAttribute('data-cart-qty'), 10) || 1 : 1;
          let next2 = q2 + 1;
          setRowQtyOptimistic(root, line2, next2);
          commitLineSoon(root, line2, next2);
          return;
        }
        let rm = t.closest('[data-cart-remove]');
        if (rm) {
          e.preventDefault();
          let line3 = parseInt(rm.getAttribute('data-cart-remove'), 10);
          changeLine(line3, 0, root);
          return;
        }
        if (t.closest('[data-wld-cart-toast-close="' + sid + '"]')) {
          e.preventDefault();
          hideToast(root);
          return;
        }
        if (t.closest('[data-wld-cart-error-toast-close="' + sid + '"]')) {
          e.preventDefault();
          let et = root.querySelector('[data-wld-cart-error-toast="' + sid + '"]');
          if (et) et.classList.remove('is-visible');
          return;
        }
        if (t.closest('[data-wld-cart-toast-open="' + sid + '"]')) {
          e.preventDefault();
          hideToast(root);
          setOpen(root, true);
          let closeBtn = root.querySelector('[data-wld-cart-close="' + sid + '"]');
          if (closeBtn && closeBtn.focus) closeBtn.focus();
        }
      });

      if (trigger && !trigger.dataset.wldCartTriggerBound) {
        trigger.dataset.wldCartTriggerBound = '1';
        trigger.setAttribute('aria-expanded', 'false');
        trigger.setAttribute('aria-haspopup', 'dialog');
        trigger.addEventListener('click', function (e) {
          e.preventDefault();
          let r = getRoot();
          if (!r) return;
          if (isOpen(r)) {
            setOpen(r, false);
            trigger.focus();
          } else {
            setOpen(r, true);
            let rid = sectionIdFromRoot(r);
            let closeBtn = r.querySelector('[data-wld-cart-close="' + rid + '"]');
            if (closeBtn && closeBtn.focus) closeBtn.focus();
          }
        });
      }

      let bd = root.querySelector('[data-wld-cart-bd="' + sid + '"]');
      if (bd) {
        bd.addEventListener('click', function () {
          setOpen(root, false);
          if (trigger && trigger.focus) trigger.focus();
        });
      }
    }

    function init() {
      disableDeliveryAutoOpen();
      let root = getRoot();
      if (!root || root.getAttribute('data-wld-cart-init') === '1') return;
      root.setAttribute('data-wld-cart-init', '1');
      syncCartEmptyState(root);
      syncHeaderFreeShippingTag(root);
      bind(root);
      observeShippingDeliveryWording(root);
      if (!document.body.dataset.wldCartEscBound) {
        document.body.dataset.wldCartEscBound = '1';
        document.addEventListener('keydown', function (e) {
          if (e.key !== 'Escape') return;
          let r = document.querySelector('[data-wld-cart-root="' + sectionId + '"]');
          if (!r || !isOpen(r)) return;
          setOpen(r, false);
          let tr = document.getElementById('wld-nav-cart-btn');
          if (tr && tr.focus) tr.focus();
        });
      }
      if (!document.body.dataset.wldCartOutsideClickBound) {
        document.body.dataset.wldCartOutsideClickBound = '1';
        document.addEventListener('click', function (e) {
          let r = document.querySelector('[data-wld-cart-root="' + sectionId + '"]');
          if (!r || !isOpen(r)) return;
          let sid = sectionIdFromRoot(r);
          let panel = r.querySelector('[data-wld-cart-panel="' + sid + '"]');
          let trigger = document.getElementById('wld-nav-cart-btn');
          let target = e.target;
          if (!panel || panel.contains(target)) return;
          if (trigger && trigger.contains(target)) return;
          if (target.closest && target.closest('[data-wld-cart-toast="' + sid + '"]')) return;
          setOpen(r, false);
          if (trigger && trigger.focus) trigger.focus();
        }, true);
      }
      /* Horizon: ThemeEvents.cartUpdate === 'cart:update' (see theme/assets/events.js) after product-form / quick-add; refresh all WLD cart drawer instances. */
      if (!document.body.dataset.wldCartDrawerThemeCartUpdate) {
        document.body.dataset.wldCartDrawerThemeCartUpdate = '1';
        document.addEventListener('cart:update', function (ev) {
          let d = ev.detail;
          if (d && d.resource && typeof d.resource.item_count === 'number') {
            updateHeaderCount(d.resource.item_count);
            document.querySelectorAll('[data-wld-cart-root]').forEach(function (r) {
              syncCartEmptyState(r, d.resource.item_count);
              if (typeof d.resource.total_price === 'number') {
                syncHeaderFreeShippingTag(r, d.resource.total_price);
              }
            });
          }
          /* The drawer's own line changes already refresh + skip the toast — don't
             react to the event we dispatched ourselves (avoids double refresh/toast). */
          let src = d && (d.source || (d.data && d.data.source));
          if (src === 'wld-cart-drawer') return;

          /* Product-card stepper edits: keep them light. Only refresh the (heavy)
             drawer lines if it's actually open; otherwise just mark it dirty and
             defer the refresh until the user opens it. No toast for card +/-. */
          if (src === 'wld-product-card') {
            document.querySelectorAll('[data-wld-cart-root]').forEach(function (r) {
              if (isOpen(r)) {
                refreshInner(r);
              } else {
                scheduleBackgroundRefresh(r);
              }
            });
            return;
          }

          /* Other adds (product page, quick add): show the toast now and re-render
             the drawer — right away if open, otherwise in the background. */
          document.querySelectorAll('[data-wld-cart-root]').forEach(function (r) {
            showToast(r, d);
            if (isOpen(r)) {
              refreshInner(r);
            } else {
              scheduleBackgroundRefresh(r);
            }
          });
        });
      }

      /* Global stock-error toast — registered once. Any surface dispatches
         `cart:stock-error` with optional detail.message. */
      if (!document.body.dataset.wldCartStockError) {
        document.body.dataset.wldCartStockError = '1';
        document.addEventListener('cart:stock-error', function (ev) {
          let message = ev && ev.detail && ev.detail.message;
          document.querySelectorAll('[data-wld-cart-root]').forEach(function (r) {
            showErrorToast(r, message);
          });
        });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (ev) {
      if (!ev.detail || String(ev.detail.sectionId) !== String(sectionId)) return;
      let root = getRoot();
      if (root) root.removeAttribute('data-wld-cart-init');
      init();
    });
    }

  document.querySelectorAll('[data-wld-cart-root]').forEach(function (rootEl) {
    wldCartDrawerInstance(
      rootEl.getAttribute('data-wld-cart-root'),
      rootEl.getAttribute('data-wld-pending-status') || '',
      rootEl.getAttribute('data-wld-pending-cta') || 'Välj leveranssätt'
    );
  });
})();

  (function () {
    if (window.__wldExactWeightInfoBound) return;
    window.__wldExactWeightInfoBound = true;

    function closeInfo(panel) {
      if (!panel) return;
      panel.hidden = true;
      var id = panel.getAttribute('data-exact-weight-info');
      var trigger = document.querySelector('[data-exact-weight-info-open="' + id + '"]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }

    document.addEventListener('click', function (event) {
      var openButton = event.target.closest('[data-exact-weight-info-open]');
      if (openButton) {
        var id = openButton.getAttribute('data-exact-weight-info-open');
        var panel = document.querySelector('[data-exact-weight-info="' + id + '"]');
        if (!panel) return;
        var willOpen = panel.hidden;
        panel.hidden = !willOpen;
        openButton.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        return;
      }

      var closeButton = event.target.closest('[data-exact-weight-info-close]');
      if (closeButton) closeInfo(closeButton.closest('[data-exact-weight-info]'));
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('[data-exact-weight-info]:not([hidden])').forEach(closeInfo);
    });
  })();

  (function () {
    if (window.__wldCompactDeliveryBound) return;
    window.__wldCompactDeliveryBound = true;

    var WLD_MONTHS = [
      'januari', 'februari', 'mars', 'april', 'maj', 'juni',
      'juli', 'augusti', 'september', 'oktober', 'november', 'december'
    ];
    var WLD_WEEKDAYS = ['söndag', 'måndag', 'tisdag', 'onsdag', 'torsdag', 'fredag', 'lördag'];
    var WLD_HOME_WINDOWS = {
      0: '10–22',
      1: '12–22',
      2: '12–22',
      3: '12–22',
      4: '12–22',
      5: '12–22',
      6: '9–18'
    };

    function parseWldDate(value) {
      var match = String(value || '').match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (!match) return null;
      return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]), 12);
    }

    function wldDateKey(date) {
      if (!date) return '';
      return [
        date.getFullYear(),
        String(date.getMonth() + 1).padStart(2, '0'),
        String(date.getDate()).padStart(2, '0')
      ].join('-');
    }

    function formatWldDate(value) {
      var date = value instanceof Date ? value : parseWldDate(value);
      if (!date) return '';
      var label = WLD_WEEKDAYS[date.getDay()] + ' ' + date.getDate() + ' ' + WLD_MONTHS[date.getMonth()];
      return label.replace(/^./, function (letter) { return letter.toUpperCase(); });
    }

    function homeWindowForDate(date) {
      return date ? (WLD_HOME_WINDOWS[date.getDay()] || '') : '';
    }

    function makeGgIcon(element, glyph) {
      if (!element) return;
      element.classList.add('ggicon');
      element.textContent = glyph;
    }

    function enhanceDeliveryPicker(root) {
      if (!root || root.dataset.wldCompactDelivery === 'true') return;
      root.dataset.wldCompactDelivery = 'true';
      root.classList.add('gg-delivery--wld-compact');

      var step1 = root.querySelector('[data-gg-step="1"]');
      var step2 = root.querySelector('[data-gg-step="2"]');
      var step5 = root.querySelector('[data-gg-step="5"]');
      var drawer = root.querySelector('.gg-delivery__drawer');
      var heading = root.querySelector('.gg-delivery__header h2');
      var eyebrow = root.querySelector('.gg-delivery__eyebrow');
      var closeIcon = root.querySelector('.gg-delivery__close span');
      var methodHeading = root.querySelector('[data-gg-step="2"] .gg-delivery__intro h3');
      var backButton = root.querySelector('[data-gg-back]');
      var postcodeButton = root.querySelector('[data-gg-zipcode-submit]');
      var postcodeInput = root.querySelector('[data-gg-zipcode]');
      var postcodeForm = root.querySelector('[data-gg-zipcode-form]');
      var postcodeWrap = postcodeInput && postcodeInput.closest('.gg-delivery__postcode');
      var postcodeStatus = root.querySelector('[data-gg-status]');
      var confirmButton = root.querySelector('[data-gg-confirm]');
      var deliveryTabs = root.querySelector('.gg-delivery__tabs');
      var homeTab = root.querySelector('[data-gg-delivery-tab]');
      var pickupTab = root.querySelector('[data-gg-pickup-tab]');
      var locationList = root.querySelector('[data-gg-location-list]');
      var calendarDays = root.querySelector('[data-gg-calendar-days]');
      var selectedDate = root.querySelector('[data-gg-selected-date]');
      var selectedWeek = root.querySelector('[data-gg-selected-week]');
      var selectedTime = root.querySelector('[data-gg-selected-time]');
      var dateCard = root.querySelector('[data-gg-date-card]');
      var editDateButton = root.querySelector('[data-gg-edit-date]');
      var deliveryBody = root.querySelector('.gg-delivery__body');
      var dateFlow = root.querySelector('[data-gg-date-flow]');
      var flowHeading = root.querySelector('[data-gg-date-flow] .gg-delivery__flow-heading h3');
      var flowDescription = root.querySelector('[data-gg-date-flow] .gg-delivery__flow-heading p');
      var flowHeadingWrap = flowHeading && flowHeading.closest('.gg-delivery__flow-heading');
      var digitInputs = [];
      var lastSubmittedZip = '';
      var pickupMonth = null;
      var pickupPlace = null;
      var completedPickupStep = null;
      var completedDateStep = null;
      var unavailableHomeNote = null;

      if (heading) heading.textContent = 'Välj leveranssätt';
      if (eyebrow) {
        eyebrow.textContent = 'Ange ditt postnummer för att se tillgängliga alternativ och dagar för hemleverans eller leverans till ett utlämningsställe.';
        eyebrow.classList.add('wld-delivery-description');
        if (deliveryBody) deliveryBody.prepend(eyebrow);
      }
      if (closeIcon) {
        makeGgIcon(closeIcon, 'O');
        var closeButton = closeIcon.closest('.gg-delivery__close');
        if (closeButton && !closeButton.querySelector('.wld-delivery-close-label')) {
          var closeLabel = document.createElement('span');
          closeLabel.className = 'wld-delivery-close-label';
          closeLabel.textContent = 'STÄNG';
          closeButton.append(closeLabel);
        }
      }
      if (methodHeading) methodHeading.textContent = '1. Välj leveranssätt';
      if (backButton) backButton.textContent = 'Ändra postnummer';
      if (confirmButton) confirmButton.textContent = 'Bekräfta';

      if (deliveryTabs && homeTab && pickupTab) {
        unavailableHomeNote = document.createElement('p');
        unavailableHomeNote.className = 'wld-delivery-method-note';
        unavailableHomeNote.id = (root.id || 'GgDelivery') + '-home-unavailable';
        unavailableHomeNote.setAttribute('role', 'status');
        unavailableHomeNote.textContent = 'Hemleverans är inte tillgänglig för det här postnumret.';
        deliveryTabs.after(unavailableHomeNote);
      }

      if (dateFlow && flowHeadingWrap) {
        completedPickupStep = document.createElement('button');
        completedPickupStep.type = 'button';
        completedPickupStep.className = 'wld-process-step-summary wld-process-step-summary--pickup';
        completedPickupStep.hidden = true;
        completedPickupStep.setAttribute('aria-label', 'Ändra utlämningsställe');

        completedDateStep = document.createElement('button');
        completedDateStep.type = 'button';
        completedDateStep.className = 'wld-process-step-summary wld-process-step-summary--date';
        completedDateStep.hidden = true;
        completedDateStep.setAttribute('aria-label', 'Ändra vald dag');

        dateFlow.insertBefore(completedPickupStep, flowHeadingWrap);
        dateFlow.insertBefore(completedDateStep, flowHeadingWrap);
      }

      var stickyConfirmButton = null;
      if (confirmButton) {
        var confirmFooter = document.createElement('div');
        confirmFooter.className = 'wld-delivery-confirm-footer';

        stickyConfirmButton = document.createElement('button');
        stickyConfirmButton.type = 'button';
        stickyConfirmButton.className = 'wld-delivery-confirm-button';
        stickyConfirmButton.textContent = 'Bekräfta';
        stickyConfirmButton.disabled = confirmButton.disabled;
        stickyConfirmButton.addEventListener('click', function () {
          if (stickyConfirmButton.disabled) return;
          confirmButton.click();
          returnToCartAfterConfirmation();
        });

        confirmFooter.append(stickyConfirmButton);
        root.append(confirmFooter);

        new MutationObserver(function () {
          stickyConfirmButton.disabled = confirmButton.disabled;
        }).observe(confirmButton, { attributes: true, attributeFilter: ['disabled'] });
      }

      root.querySelectorAll('[data-gg-prev-month]').forEach(function (button) {
        makeGgIcon(button, 'J');
      });
      root.querySelectorAll('[data-gg-next-month]').forEach(function (button) {
        makeGgIcon(button, 'K');
      });

      function syncOriginalPostcode() {
        if (!postcodeInput) return '';
        var raw = digitInputs.map(function (input) { return input.value; }).join('').replace(/\D/g, '').slice(0, 5);
        postcodeInput.value = raw.length > 3 ? raw.slice(0, 3) + ' ' + raw.slice(3) : raw;
        postcodeInput.dispatchEvent(new Event('input', { bubbles: true }));
        return raw;
      }

      function submitCompletedPostcode() {
        var raw = syncOriginalPostcode();
        if (raw.length !== 5 || raw === lastSubmittedZip || !postcodeForm) return;
        lastSubmittedZip = raw;
        if (typeof postcodeForm.requestSubmit === 'function') postcodeForm.requestSubmit();
        else postcodeForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }

      function fillDigits(value) {
        var digits = String(value || '').replace(/\D/g, '').slice(0, 5).split('');
        digitInputs.forEach(function (input, index) {
          input.value = digits[index] || '';
        });
      }

      function syncPostcodeSearchVisibility() {
        if (!postcodeButton) return;
        var hasCompletePostcode = digitInputs.length === 5 && digitInputs.every(function (input) {
          return input.value.length === 1;
        });
        postcodeButton.hidden = !hasCompletePostcode || Boolean(step2 && !step2.hidden);
      }

      function createSegmentedPostcode() {
        if (!postcodeWrap || !postcodeInput || postcodeWrap.querySelector('.wld-delivery-postcode-row')) return;
        postcodeInput.tabIndex = -1;
        postcodeInput.setAttribute('aria-hidden', 'true');

        var label = document.createElement('span');
        label.className = 'wld-delivery-postcode-label';
        label.textContent = 'Postnummer';

        var row = document.createElement('div');
        row.className = 'wld-delivery-postcode-row';
        var digitsWrap = document.createElement('div');
        digitsWrap.className = 'wld-delivery-postcode-digits';
        digitsWrap.setAttribute('role', 'group');
        digitsWrap.setAttribute('aria-label', 'Postnummer, fem siffror');

        for (var index = 0; index < 5; index += 1) {
          var digit = document.createElement('input');
          digit.type = 'text';
          digit.inputMode = 'numeric';
          digit.autocomplete = index === 0 ? 'postal-code' : 'off';
          digit.maxLength = 1;
          digit.className = 'wld-delivery-postcode-digit';
          digit.setAttribute('aria-label', 'Postnummer siffra ' + (index + 1) + ' av 5');
          digit.dataset.wldPostcodeIndex = String(index);
          digitsWrap.append(digit);
          digitInputs.push(digit);
        }

        row.append(digitsWrap);
        if (postcodeButton) {
          postcodeButton.textContent = 'Sök leveransalternativ';
          postcodeButton.classList.add('wld-delivery-postcode-search');
          row.append(postcodeButton);
        }
        if (backButton) row.append(backButton);
        postcodeWrap.prepend(label, row);
        fillDigits(postcodeInput.value);
        syncPostcodeSearchVisibility();

        digitInputs.forEach(function (input, index) {
          input.addEventListener('input', function () {
            input.value = input.value.replace(/\D/g, '').slice(-1);
            syncOriginalPostcode();
            if (input.value && index < digitInputs.length - 1) digitInputs[index + 1].focus();
            if (digitInputs.every(function (part) { return part.value.length === 1; })) {
              window.setTimeout(submitCompletedPostcode, 0);
            }
            syncPostcodeSearchVisibility();
          });
          input.addEventListener('keydown', function (event) {
            if (event.key === 'Backspace' && !input.value && index > 0) {
              digitInputs[index - 1].focus();
              digitInputs[index - 1].value = '';
              syncOriginalPostcode();
              syncPostcodeSearchVisibility();
            }
            if (event.key === 'ArrowLeft' && index > 0) digitInputs[index - 1].focus();
            if (event.key === 'ArrowRight' && index < digitInputs.length - 1) digitInputs[index + 1].focus();
          });
          input.addEventListener('paste', function (event) {
            var pasted = (event.clipboardData || window.clipboardData).getData('text').replace(/\D/g, '').slice(0, 5);
            if (!pasted) return;
            event.preventDefault();
            fillDigits(pasted);
            syncOriginalPostcode();
            var focusIndex = Math.min(pasted.length, 5) - 1;
            if (digitInputs[focusIndex]) digitInputs[focusIndex].focus();
            if (pasted.length === 5) window.setTimeout(submitCompletedPostcode, 0);
            syncPostcodeSearchVisibility();
          });
        });

        if (backButton) {
          backButton.addEventListener('click', function () {
            lastSubmittedZip = '';
            window.setTimeout(function () {
              digitInputs.forEach(function (input) { input.readOnly = false; });
              syncPostcodeSearchVisibility();
              if (digitInputs[0]) digitInputs[0].focus();
            }, 0);
          });
        }
      }

      function normalizeHomeDates() {
        root.querySelectorAll('.gg-delivery__weekdays span').forEach(function (weekday, index) {
          weekday.classList.toggle('is-weekend', index >= 5);
        });
        if (calendarDays) {
          calendarDays.querySelectorAll('button[data-date]').forEach(function (button) {
            var label = formatWldDate(button.dataset.date);
            var date = parseWldDate(button.dataset.date);
            var deliveryWindow = homeWindowForDate(date);
            var isAvailable = !button.disabled;

            button.textContent = '';
            button.classList.add('wld-home-calendar__day');

            var dayNumber = document.createElement('span');
            dayNumber.className = 'wld-home-calendar__date';
            dayNumber.textContent = date ? String(date.getDate()) : '';
            button.append(dayNumber);

            if (isAvailable && deliveryWindow) {
              var time = document.createElement('span');
              time.className = 'wld-home-calendar__time';
              var timeValue = document.createElement('span');
              timeValue.textContent = deliveryWindow;
              time.append(timeValue);
              button.append(time);
            }

            if (label) {
              button.setAttribute(
                'aria-label',
                label + (isAvailable && deliveryWindow ? ', leveranstid ' + deliveryWindow : ', inte tillgänglig')
              );
            }
            button.classList.toggle('is-weekend', Boolean(date && (date.getDay() === 0 || date.getDay() === 6)));
          });
        }
        if (isPickupActive() || root.classList.contains('is-wld-date-selected')) return;
        var chosen = calendarDays && calendarDays.querySelector('button.is-selected[data-date]');
        if (chosen && selectedDate) selectedDate.textContent = formatWldDate(chosen.dataset.date);
      }

      function resetHomeDeliveryAvailability() {
        if (!homeTab) return;
        homeTab.classList.remove('is-wld-unavailable');
        homeTab.removeAttribute('aria-label');
        homeTab.removeAttribute('aria-describedby');
        homeTab.removeAttribute('title');
        if (unavailableHomeNote) unavailableHomeNote.classList.remove('is-visible');
      }

      function syncHomeDeliveryAvailability() {
        if (!step2 || step2.hidden || !homeTab || !pickupTab) {
          resetHomeDeliveryAvailability();
          return;
        }
        if (homeTab.classList.contains('is-wld-unavailable')) {
          homeTab.hidden = false;
          return;
        }
        if (!homeTab.hidden || pickupTab.hidden) return;
        homeTab.hidden = false;
        homeTab.classList.add('is-wld-unavailable');
        homeTab.classList.remove('is-active');
        homeTab.setAttribute('aria-selected', 'false');
        homeTab.setAttribute('aria-label', 'Hemleverans, inte tillgänglig för det här postnumret');
        homeTab.setAttribute('title', 'Hemleverans är inte tillgänglig för det här postnumret.');
        if (unavailableHomeNote) homeTab.setAttribute('aria-describedby', unavailableHomeNote.id);
      }

      function isPickupActive() {
        return Boolean(pickupTab && pickupTab.classList.contains('is-active'));
      }

      function selectedPickupName() {
        var name = pickupPlace && pickupPlace.querySelector('.gg-delivery__pickup-name');
        return name ? name.textContent.trim() : '';
      }

      function setProcessStepSummary(button, label, value) {
        if (!button) return;
        button.textContent = '';
        if (!value) return;
        var labelElement = document.createElement('span');
        labelElement.className = 'wld-process-step-summary__label';
        labelElement.textContent = label;
        var valueElement = document.createElement('span');
        valueElement.className = 'wld-process-step-summary__value';
        valueElement.textContent = ' (' + value + ')';
        button.append(labelElement, valueElement);
      }

      function syncProcessSteps() {
        var pickupActive = isPickupActive();
        var dateSelected = root.classList.contains('is-wld-date-selected');
        var pickupSelected = pickupActive && Boolean(pickupPlace);

        if (methodHeading) {
          methodHeading.textContent = '1. Välj leveranssätt';
          methodHeading.classList.remove('wld-process-step-heading', 'is-wld-process-complete');
          methodHeading.removeAttribute('role');
          methodHeading.removeAttribute('tabindex');
          methodHeading.removeAttribute('aria-label');
        }

        if (completedPickupStep) {
          completedPickupStep.hidden = !pickupSelected;
          setProcessStepSummary(
            completedPickupStep,
            '2. Välj utlämningsställe',
            pickupSelected ? selectedPickupName() : ''
          );
        }

        if (completedDateStep) {
          completedDateStep.hidden = !dateSelected;
          setProcessStepSummary(
            completedDateStep,
            pickupActive ? '3. Välj dag' : '2. Välj dag',
            dateSelected && selectedDate ? selectedDate.textContent.trim() : ''
          );
        }

        if (flowHeadingWrap) flowHeadingWrap.hidden = pickupSelected && !dateSelected;
      }

      function formatStopDate(rawText) {
        var raw = String(rawText || '').replace(/^Beställ senast:?\s*/i, '').trim();
        var match = raw.match(/^(?:([A-Za-zÅÄÖåäö]+)\s+)?(\d{1,2})\/(\d{1,2})$/);
        if (!match) return raw.replace(/^./, function (letter) { return letter.toLowerCase(); });
        var monthIndex = Number(match[3]) - 1;
        var prefix = match[1] ? match[1].toLowerCase() + ' ' : '';
        return prefix + Number(match[2]) + ' ' + (WLD_MONTHS[monthIndex] || '');
      }

      function formatDeliveryWindow(rawText) {
        var match = String(rawText || '').match(/(\d{1,2})(?::\d{2})?\s*[–-]\s*(\d{1,2})(?::\d{2})?/);
        if (!match) return '';
        return String(match[1]).padStart(2, '0') + ':00–' + String(match[2]).padStart(2, '0') + ':00';
      }

      function rememberDeliveryWindow(value) {
        if (!value) return;
        try {
          window.localStorage.setItem('wldDeliveryWindow', value);
        } catch (error) {}
      }

      function setFlowCopy(selected, method) {
        if (flowHeading) {
          var headingText = selected
            ? (method === 'pickup' ? '4. Vald dag' : '3. Vald dag')
            : (method === 'pickup' ? '2. Välj utlämningsställe' : '2. Välj dag & tidsfönster');
          if (flowHeading.textContent.trim() !== headingText) flowHeading.textContent = headingText;
        }
        if (!flowDescription) {
          syncProcessSteps();
          return;
        }
        if (!selected) {
          flowDescription.textContent = method === 'pickup'
            ? 'Utlämningsställena visas i postnummerordning, från söder till norr. Scrolla för att hitta ett utlämningsställe nära dig.'
            : 'Välj en leveransdag. Tiden under datumet visar dagens leveransfönster.';
        } else if (method === 'pickup') {
          flowDescription.textContent = 'Hämtning sker på leveransdagen efter avisering, fram till att butiken stänger. Du aviseras per SMS när varorna kommit till butiken. Leverans till butiken sker mellan kl 08.00–16.00.';
        } else {
          flowDescription.textContent = 'Dina varor levereras i obruten kyl- och fryskedja med Gordon Delivery. 1–2 dagar innan leverans får du ett sms med en mer exakt leveranstid inom ditt valda leveransfönster.';
        }
        syncProcessSteps();
      }

      function removeFinalPickupChange() {
        var existing = root.querySelector('.wld-pickup-final-change-place');
        if (existing) existing.remove();
      }

      function ensureDateCardLine(className) {
        if (!dateCard) return null;
        var copy = dateCard.querySelector(':scope > span:nth-child(2)');
        if (!copy) return null;
        var line = copy.querySelector('.' + className);
        if (!line) {
          line = document.createElement('small');
          line.className = className;
          copy.append(line);
        }
        return line;
      }

      function setDateCardLabeledValue(line, label, value) {
        if (!line) return;
        line.textContent = '';
        line.hidden = !value;
        if (!value) return;
        var labelElement = document.createElement('span');
        labelElement.className = 'wld-delivery-inline-label';
        labelElement.textContent = label + ':';
        line.append(labelElement, document.createTextNode(' ' + value));
      }

      function pickupStopText(radio) {
        var row = radio && radio.closest('.gg-delivery__pickup-date');
        var stop = row && row.querySelector('.gg-delivery__pickup-date-text small');
        return stop ? stop.textContent : '';
      }

      function showFinalDateView(method, dateKey, radio) {
        if (!dateCard || !dateKey) return;
        root.classList.add('is-wld-date-selected');
        root.classList.toggle('is-wld-pickup-date-selected', method === 'pickup');
        dateCard.hidden = false;
        if (selectedDate) selectedDate.textContent = formatWldDate(dateKey);
        if (selectedWeek) selectedWeek.hidden = true;
        if (editDateButton) editDateButton.hidden = false;
        var summaryIcon = dateCard.querySelector('.gg-delivery__summary-icon');
        makeGgIcon(summaryIcon, 'X');
        setFlowCopy(true, method);

        var stopLine = ensureDateCardLine('wld-delivery-stop-line');
        var windowLine = ensureDateCardLine('wld-delivery-window-line');
        var locationLine = ensureDateCardLine('wld-delivery-location-line');
        var stopSource = '';

        if (method === 'pickup') {
          stopSource = pickupStopText(radio);
          if (locationLine) {
            var placeName = pickupPlace && pickupPlace.querySelector('.gg-delivery__pickup-name');
            setDateCardLabeledValue(locationLine, 'Utlämningsställe', placeName ? placeName.textContent.trim() : '');
          }
          if (windowLine) {
            windowLine.textContent = '';
            windowLine.hidden = true;
          }
        } else {
          var homeStop = root.querySelector('.gg-delivery__home-stop');
          stopSource = homeStop ? homeStop.textContent : '';
          if (locationLine) {
            locationLine.textContent = '';
            locationLine.hidden = true;
          }
          if (windowLine) {
            var deliveryWindow = formatDeliveryWindow(selectedTime ? selectedTime.textContent : '');
            setDateCardLabeledValue(
              windowLine,
              'Leveranstid',
              deliveryWindow
            );
            rememberDeliveryWindow(deliveryWindow);
          }
        }

        if (stopLine) {
          var formattedStop = formatStopDate(stopSource);
          stopLine.textContent = '';
          stopLine.hidden = !formattedStop;
          if (formattedStop) {
            var stopLabel = document.createElement('span');
            stopLabel.className = 'wld-delivery-stop-label';
            stopLabel.textContent = 'Beställ senast: ';
            stopLine.append(stopLabel, document.createTextNode(formattedStop));
          }
        }
        if (selectedTime) selectedTime.hidden = true;

        removeFinalPickupChange();
        updatePickupIcons();
        syncProcessSteps();
      }

      function updatePickupIcons() {
        if (!locationList) return;
        locationList.querySelectorAll('.gg-delivery__pickup-mark').forEach(function (mark) {
          var place = mark.closest('.gg-delivery__pickup-place');
          var selected = Boolean(place && (place.classList.contains('is-selected') || place.classList.contains('is-wld-place-selected')));
          makeGgIcon(mark, selected ? 'X' : 'Å');
        });
        locationList.querySelectorAll('.gg-delivery__pickup-more-icon').forEach(function (icon) {
          makeGgIcon(icon, 'S');
        });
        locationList.querySelectorAll('.gg-delivery__pickup-more-chevron').forEach(function (icon) {
          makeGgIcon(icon, 'K');
        });

        var moreWrap = locationList.querySelector('.gg-delivery__pickup-more');
        var moreToggle = locationList.querySelector('.gg-delivery__pickup-more-toggle');
        if (!moreWrap || !moreToggle) return;
        var directPlaces = Array.from(locationList.children).filter(function (child) {
          return child.classList && child.classList.contains('gg-delivery__pickup-place');
        });
        var hiddenPlaces = Array.from(moreWrap.children).filter(function (child) {
          return child.classList && child.classList.contains('gg-delivery__pickup-place');
        });
        var total = directPlaces.length + hiddenPlaces.length;
        var toReveal = Math.max(0, Math.min(5 - directPlaces.length, hiddenPlaces.length));
        hiddenPlaces.slice(0, toReveal).forEach(function (place) {
          locationList.insertBefore(place, moreToggle);
        });
        hiddenPlaces = Array.from(moreWrap.children).filter(function (child) {
          return child.classList && child.classList.contains('gg-delivery__pickup-place');
        });
        if (total <= 5 || hiddenPlaces.length === 0) {
          moreToggle.hidden = true;
          moreWrap.hidden = false;
          moreWrap.classList.add('wld-pickup-more-expanded');
        } else {
          moreToggle.hidden = false;
          var moreLabel = moreToggle.querySelector('span:not(.gg-delivery__pickup-more-icon):not(.gg-delivery__pickup-more-chevron)');
          if (moreLabel) moreLabel.textContent = 'Fler alternativ (' + hiddenPlaces.length + ')';
        }
      }

      function pickupRadioEntries(place) {
        return Array.from(place.querySelectorAll('.gg-delivery__pickup-options input[type="radio"]')).map(function (radio) {
          var parts = String(radio.value || '').split('|');
          return { radio: radio, date: parts[1] || '' };
        }).filter(function (entry) { return /^\d{4}-\d{2}-\d{2}$/.test(entry.date); });
      }

      function renderPickupCalendar() {
        var existing = root.querySelector('.wld-pickup-calendar');
        if (existing) existing.remove();
        if (!pickupPlace || !locationList) return;

        var entries = pickupRadioEntries(pickupPlace);
        if (!entries.length) return;
        var selected = entries.find(function (entry) { return entry.radio.checked; });
        if (!pickupMonth) {
          var initial = parseWldDate((selected || entries[0]).date);
          pickupMonth = new Date(initial.getFullYear(), initial.getMonth(), 1, 12);
        }

        var panel = document.createElement('section');
        panel.className = 'wld-pickup-calendar';
        panel.setAttribute('aria-label', 'Välj hämtdag');

        var heading = document.createElement('h3');
        heading.className = 'wld-pickup-calendar__heading';
        heading.textContent = '3. Välj dag';
        var intro = document.createElement('p');
        intro.className = 'wld-pickup-calendar__intro';
        intro.textContent = 'Endast tillgängliga leveransdagar går att välja.';
        panel.append(heading, intro);
        var box = document.createElement('div');
        box.className = 'wld-pickup-calendar__box gg-delivery__calendar';
        var head = document.createElement('div');
        head.className = 'wld-pickup-calendar__head gg-delivery__calendar-head';
        var previous = document.createElement('button');
        previous.type = 'button';
        previous.className = 'wld-pickup-calendar__nav gg-delivery__calendar-nav ggicon';
        previous.textContent = 'J';
        previous.setAttribute('aria-label', 'Föregående månad');
        var title = document.createElement('strong');
        title.textContent = WLD_MONTHS[pickupMonth.getMonth()].replace(/^./, function (letter) { return letter.toUpperCase(); }) + ' ' + pickupMonth.getFullYear();
        var next = document.createElement('button');
        next.type = 'button';
        next.className = 'wld-pickup-calendar__nav gg-delivery__calendar-nav ggicon';
        next.textContent = 'K';
        next.setAttribute('aria-label', 'Nästa månad');
        head.append(previous, title, next);

        var weekdays = document.createElement('div');
        weekdays.className = 'wld-pickup-calendar__weekdays gg-delivery__weekdays';
        ['må', 'ti', 'on', 'to', 'fr', 'lö', 'sö'].forEach(function (day, index) {
          var span = document.createElement('span');
          span.textContent = day;
          span.classList.toggle('is-weekend', index >= 5);
          weekdays.append(span);
        });

        var days = document.createElement('div');
        days.className = 'wld-pickup-calendar__days gg-delivery__days';
        var first = new Date(pickupMonth.getFullYear(), pickupMonth.getMonth(), 1, 12);
        var leading = (first.getDay() + 6) % 7;
        var daysInMonth = new Date(pickupMonth.getFullYear(), pickupMonth.getMonth() + 1, 0).getDate();
        for (var spacer = 0; spacer < leading; spacer += 1) {
          var daySpacer = document.createElement('span');
          daySpacer.className = 'gg-delivery__day-spacer';
          days.append(daySpacer);
        }

        for (var day = 1; day <= daysInMonth; day += 1) {
          var date = new Date(pickupMonth.getFullYear(), pickupMonth.getMonth(), day, 12);
          var key = wldDateKey(date);
          var entry = entries.find(function (candidate) { return candidate.date === key; });
          var dayButton = document.createElement('button');
          dayButton.type = 'button';
          dayButton.textContent = String(day);
          dayButton.disabled = !entry;
          dayButton.dataset.date = key;
          dayButton.setAttribute('aria-label', formatWldDate(key));
          dayButton.classList.toggle('is-weekend', date.getDay() === 0 || date.getDay() === 6);
          dayButton.classList.toggle('is-selected', Boolean(entry && entry.radio.checked));
          if (entry) {
            (function (availableEntry) {
              dayButton.addEventListener('click', function () {
                entries.forEach(function (candidate) { candidate.radio.checked = false; });
                availableEntry.radio.checked = true;
                availableEntry.radio.dispatchEvent(new Event('change', { bubbles: true }));
                pickupPlace.classList.add('is-selected');
                window.setTimeout(function () {
                  showFinalDateView('pickup', availableEntry.date, availableEntry.radio);
                }, 0);
              });
            })(entry);
          }
          days.append(dayButton);
        }

        previous.addEventListener('click', function () {
          pickupMonth = new Date(pickupMonth.getFullYear(), pickupMonth.getMonth() - 1, 1, 12);
          renderPickupCalendar();
        });
        next.addEventListener('click', function () {
          pickupMonth = new Date(pickupMonth.getFullYear(), pickupMonth.getMonth() + 1, 1, 12);
          renderPickupCalendar();
        });
        box.append(head, weekdays, days);
        panel.append(box);
        locationList.after(panel);
      }

      function choosePickupPlace(place) {
        if (!place) return;
        root.querySelectorAll('.gg-delivery__pickup-place').forEach(function (candidate) {
          candidate.classList.toggle('is-wld-place-selected', candidate === place);
          if (candidate !== place) candidate.classList.remove('is-selected');
        });
        pickupPlace = place;
        pickupMonth = null;
        root.classList.add('is-wld-pickup-place-chosen');
        pickupRadioEntries(place).forEach(function (entry) { entry.radio.checked = false; });
        if (confirmButton) confirmButton.disabled = true;
        updatePickupIcons();
        renderPickupCalendar();
        syncProcessSteps();
      }

      function clearPickupPlaceSelection() {
        if (pickupPlace) {
          pickupRadioEntries(pickupPlace).forEach(function (entry) { entry.radio.checked = false; });
          pickupPlace.classList.remove('is-selected', 'is-wld-place-selected');
        }
        pickupPlace = null;
        pickupMonth = null;
        root.classList.remove('is-wld-pickup-place-chosen', 'is-wld-date-selected', 'is-wld-pickup-date-selected');
        if (dateCard) dateCard.hidden = true;
        if (confirmButton) confirmButton.disabled = true;
        var panel = root.querySelector('.wld-pickup-calendar');
        if (panel) panel.remove();
        removeFinalPickupChange();
        setFlowCopy(false, 'pickup');
        updatePickupIcons();
        syncProcessSteps();
      }

      function resetPickupView() {
        root.classList.remove('is-wld-pickup-place-chosen', 'is-wld-date-selected', 'is-wld-pickup-date-selected');
        pickupPlace = null;
        pickupMonth = null;
        root.querySelectorAll('.gg-delivery__pickup-place').forEach(function (place) {
          place.classList.remove('is-open', 'is-selected', 'is-wld-place-selected');
          var head = place.querySelector('.gg-delivery__pickup-head');
          var options = place.querySelector('.gg-delivery__pickup-options');
          if (head) head.setAttribute('aria-expanded', 'false');
          if (options) options.hidden = true;
          pickupRadioEntries(place).forEach(function (entry) { entry.radio.checked = false; });
        });
        if (confirmButton && pickupTab && pickupTab.classList.contains('is-active')) confirmButton.disabled = true;
        var calendar = root.querySelector('.wld-pickup-calendar');
        if (calendar) calendar.remove();
        removeFinalPickupChange();
        syncProcessSteps();
        window.setTimeout(updatePickupIcons, 0);
      }

      function refreshDynamicUi() {
        normalizeHomeDates();
        updatePickupIcons();
        setFlowCopy(root.classList.contains('is-wld-date-selected'), isPickupActive() ? 'pickup' : 'home');
        root.querySelectorAll('.gg-delivery__summary-icon').forEach(function (icon) {
          makeGgIcon(icon, 'X');
        });
      }

      createSegmentedPostcode();

      function reopenDateStep() {
        if (!root.classList.contains('is-wld-date-selected')) return;
        if (editDateButton) {
          editDateButton.click();
          return;
        }
        root.classList.remove('is-wld-date-selected', 'is-wld-pickup-date-selected');
        if (dateCard) dateCard.hidden = true;
        if (confirmButton) confirmButton.disabled = true;
        setFlowCopy(false, isPickupActive() ? 'pickup' : 'home');
        if (isPickupActive()) renderPickupCalendar();
      }

      if (completedPickupStep) {
        completedPickupStep.addEventListener('click', clearPickupPlaceSelection);
      }

      if (completedDateStep) {
        completedDateStep.addEventListener('click', reopenDateStep);
      }

      if (homeTab) {
        homeTab.addEventListener('click', function (event) {
          if (!homeTab.classList.contains('is-wld-unavailable')) return;
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          if (unavailableHomeNote) unavailableHomeNote.classList.toggle('is-visible');
        }, true);
        homeTab.addEventListener('keydown', function (event) {
          if (!homeTab.classList.contains('is-wld-unavailable')) return;
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          if (unavailableHomeNote) unavailableHomeNote.classList.toggle('is-visible');
        }, true);
      }

      root.addEventListener('click', function (event) {
        if (!unavailableHomeNote || event.target.closest('[data-gg-delivery-tab].is-wld-unavailable')) return;
        unavailableHomeNote.classList.remove('is-visible');
      }, true);

      root.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && unavailableHomeNote) unavailableHomeNote.classList.remove('is-visible');
      });

      root.addEventListener('click', function (event) {
        var editDate = event.target.closest('[data-gg-edit-date]');
        if (!editDate || !isPickupActive()) return;
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        root.classList.remove('is-wld-date-selected', 'is-wld-pickup-date-selected');
        if (dateCard) dateCard.hidden = true;
        if (confirmButton) confirmButton.disabled = true;
        removeFinalPickupChange();
        setFlowCopy(false, 'pickup');
        renderPickupCalendar();
      }, true);

      root.addEventListener('click', function (event) {
        var homeCalendarButton = event.target.closest('[data-gg-calendar-days] button[data-date]');
        if (homeCalendarButton && root.contains(homeCalendarButton)) {
          window.setTimeout(function () {
            showFinalDateView('home', homeCalendarButton.dataset.date);
          }, 0);
        }
        if (event.target.closest('.wld-pickup-final-change-place')) {
          clearPickupPlaceSelection();
          return;
        }
        var pickupHead = event.target.closest('.gg-delivery__pickup-head');
        if (pickupHead && root.contains(pickupHead)) {
          window.setTimeout(function () { choosePickupPlace(pickupHead.closest('.gg-delivery__pickup-place')); }, 0);
          return;
        }
        if (event.target.closest('[data-gg-pickup-tab]')) {
          resetPickupView();
          setFlowCopy(false, 'pickup');
          window.setTimeout(updatePickupIcons, 0);
        }
        if (event.target.closest('[data-gg-delivery-tab]')) {
          resetPickupView();
          setFlowCopy(false, 'home');
        }
        if (event.target.closest('[data-gg-edit-date]') && !isPickupActive()) {
          root.classList.remove('is-wld-date-selected', 'is-wld-pickup-date-selected');
          setFlowCopy(false, 'home');
        }
        window.setTimeout(refreshDynamicUi, 0);
      });

      function returnToCartAfterConfirmation() {
        if (root.dataset.wldSuccessRedirected === 'true') return;
        root.dataset.wldSuccessRedirected = 'true';
        window.setTimeout(function () {
          var closeButton = root.querySelector('.gg-delivery__close');
          if (closeButton) closeButton.click();
          window.setTimeout(function () {
            var cartTrigger = document.getElementById('wld-nav-cart-btn');
            if (cartTrigger && cartTrigger.getAttribute('aria-expanded') !== 'true') cartTrigger.click();
          }, 80);
        }, 80);
      }

      function syncSingleView() {
        var optionsVisible = Boolean(step2 && !step2.hidden);
        var successVisible = Boolean(step5 && !step5.hidden);

        if (!successVisible) delete root.dataset.wldSuccessRedirected;

        root.classList.toggle('is-wld-options', optionsVisible);
        root.classList.toggle('is-wld-success', successVisible);
        syncHomeDeliveryAvailability();

        if (step1 && optionsVisible) {
          step1.hidden = false;
          if (postcodeInput) postcodeInput.readOnly = true;
          digitInputs.forEach(function (input) { input.readOnly = true; });
          if (postcodeStatus) postcodeStatus.textContent = '';
        }
        if (postcodeInput && !optionsVisible && !successVisible) {
          postcodeInput.readOnly = false;
          digitInputs.forEach(function (input) { input.readOnly = false; });
        }
        syncPostcodeSearchVisibility();
        if (step1 && successVisible) step1.hidden = true;
        if (successVisible) returnToCartAfterConfirmation();
        if (optionsVisible) {
          window.setTimeout(function () {
            refreshDynamicUi();
            if (!root.classList.contains('is-wld-date-selected')) {
              setFlowCopy(false, isPickupActive() ? 'pickup' : 'home');
            }
          }, 0);
        }
      }

      syncSingleView();
      var stateObserver = new MutationObserver(syncSingleView);
      if (step2) stateObserver.observe(step2, { attributes: true, attributeFilter: ['hidden'] });
      if (step5) stateObserver.observe(step5, { attributes: true, attributeFilter: ['hidden'] });
      if (homeTab) {
        new MutationObserver(syncHomeDeliveryAvailability).observe(homeTab, {
          attributes: true,
          attributeFilter: ['hidden']
        });
      }
      if (flowHeading) {
        new MutationObserver(function () {
          setFlowCopy(root.classList.contains('is-wld-date-selected'), isPickupActive() ? 'pickup' : 'home');
        }).observe(flowHeading, { childList: true, characterData: true, subtree: true });
      }
      if (drawer) {
        new MutationObserver(function () {
          if (!drawer.classList.contains('is-open')) return;
          window.setTimeout(function () {
            fillDigits(postcodeInput ? postcodeInput.value : '');
            syncPostcodeSearchVisibility();
          }, 0);
        }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
      }
    }

    function findDeliveryPicker(attempt) {
      var roots = document.querySelectorAll('[data-grona-delivery]');
      roots.forEach(enhanceDeliveryPicker);
      if (!roots.length && attempt < 25) {
        window.setTimeout(function () {
          findDeliveryPicker(attempt + 1);
        }, 200);
      }
    }

    function initCompactDelivery() {
      findDeliveryPicker(0);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCompactDelivery, { once: true });
    } else {
      initCompactDelivery();
    }

    document.addEventListener('shopify:section:load', initCompactDelivery);
  })();
